export function isZeroUUID(uuid: string) {
  return uuid === NullUUID;
}

export const NullUUID = "00000000-0000-0000-0000-000000000000";
